<ion-header>
  <ion-toolbar>
    <ion-title>Actualización Requerida</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; text-align: center; padding-top: 2rem;">

    <!-- Icono de actualización -->
    <div style="width: 80px; height: 80px; border-radius: 50%; background: var(--light-grey); border: 4px solid var(--black); display: flex; align-items: center; justify-content: center; margin-bottom: 24px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 512 512" fill="var(--black)">
        <path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"/>
      </svg>
    </div>

    <!-- Texto -->
    <div class="customer-info" [style.color]="'var(--primary)'" style="border: none; padding-bottom: 0;">
      <h2 class="ion-text-center" [style.color]="'var(--primary)'" [style.margin-bottom]="'16px'" [style.font-size]="'1.4rem'">
        Actualización disponible
      </h2>
      <p [style.margin]="'0 0 16px 0'" [style.opacity]="'0.9'">
        Hay una nueva versión de la aplicación disponible. Debes actualizar para continuar usando la app.
      </p>
    </div>

    <!-- Detalles de Versión -->
    <!-- <ion-card [style.background]="'rgba(250, 244, 211, 0.1)'" 
              [style.border]="'1px solid rgba(222, 124, 0, 0.3)'"
              [style.border-radius]="'12px'"
              [style.margin-top]="'16px'"
              [style.width]="'100%'"
              [style.box-shadow]="'none'">
      <ion-card-content>
        <p *ngIf="currentVersion" [style.color]="'var(--primary)'" [style.margin]="'4px 0'">
          Tu versión: <strong [style.color]="'var(--secondary)'">{{ currentVersion }}</strong>
        </p>
        <p *ngIf="minVersion" [style.color]="'var(--primary)'" [style.margin]="'4px 0'">
          Versión requerida: <strong [style.color]="'var(--secondary)'">{{ minVersion }}</strong>
        </p>
      </ion-card-content>
    </ion-card> -->

    <div style="padding-top: 32px; width: 100%;">
      <app-button 
        [submit]="false" 
        [function]="updateApp.bind(this)" 
        text="ACTUALIZAR AHORA" 
        [fullWidth]="true"
        [style.--button-background]="'var(--secondary)'"
        [style.--button-color]="'var(--primary)'"></app-button>
    </div>

  </div>
</ion-content>
